import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TALLY_URL } from "@/config/links";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className = "", lineClassName = "", startDelay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: startDelay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const CTAButton = ({ label, testId, variant = "gold", className = "", to, href }) => {
  const styles =
    variant === "gold"
      ? "bg-[#C8A97E] text-[#0B2215] hover:bg-[#0B2215] hover:text-[#C8A97E] border border-[#C8A97E]"
      : "bg-transparent text-[#F9F8F6] border border-[#C8A97E]/70 hover:bg-[#C8A97E] hover:text-[#0B2215]";
  const cls = `group inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold uppercase tracking-[0.15em] transition-colors duration-300 ${styles} ${className}`;
  const inner = (
    <>
      {label}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
    </>
  );
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls}>
        {inner}
      </Link>
    );
  }
  return (
    <a href={href || TALLY_URL} target="_blank" rel="noopener noreferrer" data-testid={testId} className={cls}>
      {inner}
    </a>
  );
};
